import { TranslationService } from '../services/translation.service';

export const createDateTranslations = (translationService: TranslationService) => {
  const translations = translationService.getTranslationSync('datePicker.labels');

  return {
    upSecondLabel: translations.upSecondLabel,
    downSecondLabel: translations.downSecondLabel,
    upMinuteLabel: translations.upMinuteLabel,
    downMinuteLabel: translations.downMinuteLabel,
    upHourLabel: translations.upHourLabel,
    downHourLabel: translations.downHourLabel,
    prevMonthLabel: translations.prevMonthLabel,
    nextMonthLabel: translations.nextMonthLabel,
    prevYearLabel: translations.prevYearLabel,
    nextYearLabel: translations.nextYearLabel,
    switchToMonthViewLabel: translations.switchToMonthViewLabel,
    switchToYearViewLabel: translations.switchToYearViewLabel,
    cancelBtnLabel: translations.cancelBtnLabel,
    setBtnLabel: translations.setBtnLabel,
    rangeFromLabel: translations.rangeFromLabel,
    rangeToLabel: translations.rangeToLabel
  };
};



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/factories/date-translations.factory.ts